import { render } from "./InvalidProduct.vue?vue&type=template&id=23efff14"
import script from "./InvalidProduct.vue?vue&type=script&lang=js"
export * from "./InvalidProduct.vue?vue&type=script&lang=js"
script.render = render

export default script